import { render, staticRenderFns } from "./WireTransferButton.vue?vue&type=template&id=4766eba9&scoped=true&"
import script from "./WireTransferButton.vue?vue&type=script&lang=js&"
export * from "./WireTransferButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4766eba9",
  null
  
)

export default component.exports